import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { benefits } from '../data/about';
import { business } from '../data/business';
import { serviceAreas } from '../data/serviceAreas';
import { ui } from '../data/ui';
export function WhyChoose() {
  const {
    t
  } = useLanguage();
  const stats = [{
    value: business.rating.toFixed(1),
    label: t(ui.why.rating),
    star: true
  }, {
    value: '7',
    label: t(ui.why.days)
  }, {
    value: String(serviceAreas.length),
    label: t(ui.why.cities)
  }];
  return <section id="about" className="section-y bg-mist" aria-labelledby="about-title" data-id="element-376" data-mp="32ddx80s84oql">
      <div className="container-page grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-377" data-mp="2oi33wrtmoboc">
        <div className="lg:col-span-5" data-id="element-378" data-mp="2tdqwlh7bjmyl">
          <h2 id="about-title" className="font-display text-[28px] font-bold leading-tight text-ink md:text-4xl" data-id="element-379" data-mp="1d0tm09q5drp5">
            {t(ui.why.title)}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-body" data-id="element-380" data-mp="1i1hmrn46hmwk">{t(ui.why.body)}</p>
          <p className="mt-4 font-medium text-navy" data-id="element-381" data-mp="28fqg01gnzvy1">{t(ui.why.owner)}</p>
          <dl className="mt-10 grid grid-cols-3 divide-x divide-line border-y border-line" data-id="element-382" data-mp="23g43ju8nujqa">
            {stats.map(s => <div key={s.label} className="flex flex-col-reverse px-4 py-5 first:pl-0" data-id="element-383" data-mp="2idwkmqtuvg6l">
                <dt className="mt-1 text-sm leading-snug text-muted" data-id="element-384" data-mp="2ddighjvdkqdu">{s.label}</dt>
                <dd className="flex items-center gap-1.5 font-display text-3xl font-extrabold text-navy" data-id="element-385" data-mp="2rd1e3iqk8jbw">
                  {s.value}
                  {s.star && <StarIcon className="h-5 w-5 fill-star text-star" aria-hidden="true" data-id="element-386" data-mp="2me6mbram7kfn" />}
                </dd>
              </div>)}
          </dl>
        </div>

        <ul className="grid content-start gap-x-10 gap-y-10 sm:grid-cols-2 lg:col-span-7 lg:pt-2" data-id="element-387" data-mp="2w5b04nok0z8w">
          {benefits.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title.en} className="flex gap-4" data-id="element-388" data-mp="362pgyoee3q1q">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-line" data-id="element-389" data-mp="3640hmfcjghom">
                <Icon className="h-6 w-6 text-leaf-strong" aria-hidden="true" data-id="element-390" data-mp="3i4qhecvozqt5" />
              </span>
              <div data-id="element-391" data-mp="3n3tmtyfl3z1n">
                <h3 className="font-display text-lg font-bold text-ink" data-id="element-392" data-mp="3n3a2yc6dj0kz">{t(title)}</h3>
                <p className="mt-1.5 leading-relaxed text-body" data-id="element-393" data-mp="3rua1flv55qpl">{t(description)}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}